import { Dispatch, SetStateAction, useMemo } from 'react';
import { useDrag } from 'react-dnd';

import { BUILDER_ROW_TYPES } from '../../../../../constants/campaignBuilder.js';
import { dragItemTypes } from '../../../../../constants/myCampaigns.js';
import { Header } from '../../../../../types/shared.js';
import HeaderDropZone from './HeaderDropZone.jsx';
import TableHeadItemContent from './TableHeadItemContent.jsx';

export type Props = {
  header: Header & {
    viewType?: string;
    isCalculated?: boolean;
    isPredictiveColumn?: boolean;
  };
  isDisabled: boolean;
  onChangeOrder: (dragId: string, dropId: string) => void;
  headerIdx?: number;
  setRef: (ref: HTMLDivElement, id: string) => void;
  expandedType?: BUILDER_ROW_TYPES;
  setExpandedType?: Dispatch<SetStateAction<BUILDER_ROW_TYPES>>;
  isResizingColumn?: string;
  scale: number;
  isPredictivePlanningMode: boolean;
};

const HeadItem = ({
  header,
  onChangeOrder,
  headerIdx,
  setRef,
  isDisabled,
  isResizingColumn,
  expandedType,
  setExpandedType,
  scale,
  isPredictivePlanningMode,
}: Props) => {
  const isDraggable = !header.isDragDisabled;
  const canDrag = () => isDraggable && !isDisabled && !isPredictivePlanningMode;

  const [{ isDragging }, drag] = useDrag({
    type: dragItemTypes.HEADER,
    item: {
      type: dragItemTypes.HEADER,
      position: header.idx,
      id: header.id,
      name: header.Header,
      width: header.width,
      isCalculated: header.isCalculated,
    },
    canDrag,

    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const preparedHeader = useMemo(
    () => ({
      ...header,
      idx: headerIdx,
    }),
    [header, header.width, headerIdx],
  );

  const handleExpandRows = () => {
    if (expandedType === BUILDER_ROW_TYPES.TILE) {
      setExpandedType?.(BUILDER_ROW_TYPES.CHANNEL);
    }

    if (expandedType === BUILDER_ROW_TYPES.CHANNEL) {
      setExpandedType?.(BUILDER_ROW_TYPES.PLATFORM);
    }

    if (expandedType === BUILDER_ROW_TYPES.PLATFORM) {
      setExpandedType?.(BUILDER_ROW_TYPES.TILE);
    }
  };

  return (
    <HeaderDropZone
      header={preparedHeader}
      onDrop={onChangeOrder}
      isDragging={isDragging}
      isResizingColumn={isResizingColumn}
      setRef={setRef}
      scale={scale}
    >
      <TableHeadItemContent
        expandedType={expandedType}
        handleExpandRows={handleExpandRows}
        header={header}
        isDisabled={isDisabled}
        drag={drag}
        scale={scale}
        isPredictivePlanningMode={isPredictivePlanningMode}
      />
    </HeaderDropZone>
  );
};

export default HeadItem;
